import authAxios from 'src/modules/shared/axios/authAxios';

export default class QuizService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(`/quiz/${id}`, body);

    return response.data;
  }

  static async destroyAll(ids) {
    const params = { ids };

    const response = await authAxios.delete(`/quiz`, { params });

    return response.data;
  }

  static async create(data) {
    const body = {data};    

    const response = await authAxios.post(`/quiz`, body);

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/quiz/${id}`);    
    
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/quiz`, { params });
    
    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(`/quiz/unarchive`, body);

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/quiz/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }

  static async quizResult(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(
      `/quiz/user/result`,
      {
        params,
      },
    );

    return response.data;
  }

  static async quizResultFind(userId, id) {
    const response = await authAxios.get(`/quiz/user/${userId}/result/${id}`);    
    
    return response.data;
  }
}
